import { CategoryRepository } from "../../../../data/repository/category/CategoryRepository";
import { QuestionRepository } from "../../../../data/repository/question/QuestionRepository";
import { Message, MessageAndIdModel } from "../../../model/Auth";
import { Category } from "../../../model/Category";
import { Question } from "../../../model/Question";
import { ResponseState, State } from "../../../model/ResponseState";

export interface CreateQuestionUseCase {
  invoke: (question: Question) => Promise<ResponseState<MessageAndIdModel>>;
}

export class CreateQuestionUseCaseImpl implements CreateQuestionUseCase {
  private questionRepository: QuestionRepository;

  constructor(questionRepository: QuestionRepository) {
    this.questionRepository = questionRepository;
  }

  async invoke(question: Question): Promise<ResponseState<MessageAndIdModel>> {
    try {
      let response = await this.questionRepository.createQuestion(question);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
